/**
 * 【菜单列表】
 */
import React from 'react';
import styles from './index.module.scss';
import { message } from 'antd';
import PropTypes from 'prop-types';
import { XOKButton, XTabNav } from '@/components/xqxc_ui';
import { connect } from 'react-redux';
import TableContent from './components/TableContent';
import CreateModal from './modal/CreateModal';
import EditModal from './modal/EditModal';
import DeleteModal from './modal/DeleteModal';
import model from '@/reducers/permissions/menuconfig/model';
import http from '@/assets/api/http';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

class Main extends React.Component {
    state = {
        tab: [
            { id: 'PLAT', label: '总控后台菜单配置' },
            { id: 'OPERATION', label: '运营公司后台菜单配置' },
            { id: 'SMART_PLATFORM', label: '智能调度系统菜单配置' },
        ],
        curTabID: 'PLAT',  // 当前显示的Tab页ID
        OpenModalType: '', // 当前打开的弹框
        openModeParam: {}, // 弹框传参
    };

    componentDidMount() {
        this.props.getAllMenuList({ systemType: this.state.curTabID });
        this.props.setBreadcrumbPaths(this.props.match); // 自动识别面包屑
    }

    // Tab页切换
    _tabChangeHandle = (tabID) => {
        this.setState({ curTabID: tabID }, () => {
            this.props.getAllMenuList({ systemType: tabID });
        });
    }

    // 表格操作
    _tableAction = (type, record) => {
        switch (type) {
            case 'edit':
                this.setState({ openModeParam: record, OpenModalType: 'edit' });
                break;
            case 'forbid':
                http('/?cmd=com.xqxc.api.pig.mis.biz.account.MenuMisService.updateMenuStatus', { id: record.id, status: 0 }, 'POST').then(() => {
                    message.success('禁用成功！');
                    this.props.getAllMenuList({ systemType: this.state.curTabID });
                }).catch((e) => {
                    message.error(e.message);
                });
                break;
            case 'start':
                http('/?cmd=com.xqxc.api.pig.mis.biz.account.MenuMisService.updateMenuStatus', { id: record.id, status: 1 }, 'POST').then(() => {
                    message.success('启用成功！');
                    this.props.getAllMenuList({ systemType: this.state.curTabID });
                }).catch((e) => {
                    message.error(e.message);
                });
                break;
            case 'del':
                this.setState({ openModeParam: { id: record.id }, OpenModalType: 'del' });
                break;
        }
    }

    //打开弹窗
    _renderMode = () => {
        switch (this.state.OpenModalType) {
            case 'new':
                return <CreateModal title='新建菜单' closeModal={this._closeModal} systemType={this.state.curTabID} />;
            case 'edit':
                return <EditModal title='编辑菜单' closeModal={this._closeModal} systemType={this.state.curTabID} openModeParam={this.state.openModeParam} />;
            case 'del':
                return <DeleteModal title='删除菜单' closeModal={this._closeModal} systemType={this.state.curTabID} id={this.state.openModeParam.id} />;
            default:
                return null;
        }
    }

    // 关闭弹窗
    _closeModal = (update) => {
        this.setState({ OpenModalType: '' });
        if (update) {
            this.props.getAllMenuList({ systemType: this.state.curTabID });
        }
    }

    // 新建菜单
    _newHandle = () => {
        this.setState({ OpenModalType: 'new' });
    };

    render() {
        const { allMenuList } = this.props;

        return (
            <div id='autoheight' className={styles.flexBoxContainer}>
                <XTabNav renderData={this.state.tab} onChange={this._tabChangeHandle} activedID={this.state.curTabID} />
                <div className={styles.row2}>
                    <XOKButton
                        style={{ width: '100px' }}
                        label='新建菜单'
                        onClick={this._newHandle}
                    />
                </div>
                <TableContent curTabID={this.state.curTabID} renderData={allMenuList} tableAction={this._tableAction} />
                {this._renderMode()}
            </div>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    getAllMenuList: PropTypes.func, // 获取全部菜单列表
    allMenuList: PropTypes.array, // 全部菜单列表
    match: PropTypes.object, // router match
    setBreadcrumbPaths: PropTypes.func,
};

const mapStateToProps = (state) => ({
    allMenuList: state.menuconfig.getAllMenuList,
});
export default connect(mapStateToProps, { ...model.actions, setBreadcrumbPaths })(Main);